import { CircularProgress } from '@mui/material';

const LoadingIndicator = () => (
  <div className='flex w-full justify-center my-36'>
    <CircularProgress />
  </div>
);

export default LoadingIndicator;
